module.exports = __webpack_public_path__ + "static/media/flower5.18c4f4e5.png";